// src/pages/TrainingShared.jsx
// Vista condivisa pubblica /training/:id: chi ha il link vede la live (se la
// sessione è in corso) oppure il replay (se è terminata e salvata).
// Nessuna password: l'id della sessione nel link fa da chiave.
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSession } from '../session';
import TrainingLive from './TrainingLive';
import TrainingDetail from './TrainingDetail';
import { ThemeToggle } from '../components/ThemeContext';
import { Icon } from '../components/icons';
import logoRaceSenseLive from '../img/logo-racesense-live.svg';
import './TrainingShared.css';

const API_BASE = process.env.REACT_APP_API_BASE || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);

export default function TrainingShared() {
  const { id } = useParams();
  const session = useSession();
  const navigate = useNavigate();
  const [err, setErr] = useState('');
  const [result, setResult] = useState(null); // { mode:'live', token, trainingId } | { mode:'replay', training }

  useEffect(() => {
    let alive = true;
    setErr(''); setResult(null);
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/api/training/${encodeURIComponent(id)}/access`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}',
        });
        const j = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(r.status === 404 ? 'Sessione non trovata: il link potrebbe essere sbagliato o la sessione eliminata.' : (j?.error || 'Sessione non disponibile'));
        if (alive) setResult(j);
      } catch (e) {
        if (alive) setErr(e.message);
      }
    })();
    return () => { alive = false; };
  }, [id]);

  if (result?.mode === 'live') {
    return <TrainingLive token={result.token} trainingId={result.trainingId || id} publicMode />;
  }
  if (result?.mode === 'replay') {
    return <TrainingDetail training={result.training} />;
  }

  return (
    <div className="rs-live-root ts-root">
      <div className="ts-theme"><ThemeToggle /></div>
      <div className="rs-card ts-card">
        <img src={logoRaceSenseLive} alt="RaceSense Live" className="ts-logo" />
        <div className="ts-head">
          <span className="rs-kicker rs-kicker--lime"><span className="rs-kicker__dot rs-kicker__dot--lime" />Sessione · Allenamento</span>
          <h1 className="ts-title">{err ? 'Sessione non disponibile' : 'Apertura sessione…'}</h1>
          {err
            ? <div className="rs-alert rs-alert--danger"><Icon.Alert /><span>{err}</span></div>
            : <p className="ts-sub"><span className="rs-spinner" /> Caricamento della telemetria.</p>}
          {err && session && (
            <button type="button" className="rs-btn rs-btn--sm rs-btn--ghost" onClick={() => navigate('/allenamenti-passati')}>
              <Icon.ArrowLeft size={15} /> Allenamenti passati
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
